import { getCookie } from '../utils/TagUtils';

export type DataRoleFieldSynonym = {
  readonly locale: string;
  readonly name: string;
  readonly weight: number;
  readonly is_primary: boolean;
};

// WebclientApis serialize using camel case rather than underscores, so we need this variant type
export type DataRoleFieldSynonymWebClient = Exclude<DataRoleFieldSynonym, 'is_primary'> & {
  readonly isPrimary: boolean;
};

export type DataRoleUpdateModel = Partial<{
  readonly name: string;
  readonly description: string;
  readonly field_concept: Partial<{
    readonly names: DataRoleFieldSynonym[];
  }>;
}>;

export const updateDataroleApi = (luid: string, updateModel: DataRoleUpdateModel): Promise<Response> => {
  if (!luid) { return Promise.reject(); }
  const TagHeaders = new Headers({ 'X-XSRF-TOKEN': getCookie('XSRF-TOKEN'), 'Content-Type': 'application/json' });

  const targetUrl = `${window.location.origin}/services/data-roles/${luid}`;
  return fetch(targetUrl, {
    body: JSON.stringify(updateModel),
    headers: TagHeaders,
    method: 'PATCH',
    cache: 'no-cache',
    credentials: 'include',
  });
};
